import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  width: '100vw',
  zIndex: 50,
  padding: theme.spacing(2.25, 2.5),
  backgroundColor: theme.palette.secondary.main,
  backdropFilter: 'blur(8px)',
  '& .STFBPrice': {
    fontSize: theme.typography.pxToRem(24),
  },
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));
export default StyledBox;
